import type { ComponentType } from "react";
import {
  Button,
  ButtonGroup,
  InlinePlayButton,
  PageSegmentControl,
} from "../components/Interactive.tsx";
import { Article, LinkTiles, ProductCards } from "../components/Bytecode.tsx";
import ContactForm from "../components/ContactForm.tsx";
import { Image, MediaFrame, Video } from "../components/Media.tsx";
import Section, {
  HomepageHero,
  Item,
  LogoTickerSection,
  Reference,
} from "../components/Section.tsx";
import TextGroup, {
  DataItem,
  Disclosure,
  DisclosureItem,
  FeatureList,
} from "../components/TextGroup.tsx";
import type { CMSNode } from "../types.ts";

type Renderer = ComponentType<{ node: CMSNode }>;

/**
 * componentType -> renderer. `null` marks config-only nodes that their parent
 * reads directly. Unregistered types fall back to UnknownComponent.
 */
export const registry: Record<string, Renderer | null> = {
  // bytecode.ca blocks
  LinkTiles,
  ProductCards,
  ContactForm,
  Article,

  // sections
  HomepageHeroRebrand: HomepageHero,
  StackSectionType: Section,
  CtaSection: Section,
  TextSectionType: Section,
  ProductValueSection: Section,
  ProductScrollType: Section,
  SplitSectionType: Section,
  CardWrappedContentSection: Section,
  MediaCarouselSection: Section,
  CtaClosingRebrand: Section,
  LogoTickerSection,
  PageSegmentControl,

  // section items
  ProductValueItem: Item,
  ProductScrollItem: Item,
  SplitSectionItem: Item,
  RelatedContentItem: Item,
  PageSegmentItem: Reference,
  TextHeaderInner: Reference,

  // text
  TextGroup,
  FeatureList,
  Disclosure,
  DisclosureItem,
  DataItemRebrand: DataItem,

  // actions (Button is rendered by bc-component-kit, see kitComponents.ts)
  ButtonGroup,
  Button,
  InlinePlayButton,

  // media
  MediaFrame,
  Image,
  Video,

  // configuration nodes and items read by their parent
  LinkTile: null,
  ProductCard: null,
  SectionTransitionConfig: null,
  CarouselDetails: null,
  ProductScrollFeaturedVariantConfig: null,
  GlobalNavConfig: null,
  VideoObject: null,
  NumberGroupRebrand: null,
  NumberRebrand: null,
};
